import { ResourceOptions } from 'react-admin';
import { FaNewspaper } from 'react-icons/fa';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.socialTradingIntel;
export const icon = FaNewspaper;
export const options: ResourceOptions = {
  label: 'module.socialTrading.intel',
};
